module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-stone-path-background-remnants.318067ea.png";